module.exports = {
      id: "vikatan-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#vikatan",
      toString: function () {
        return this.url;
      }
    }